<template>
    <div dir="rtl" style="padding: 20px; max-width: 1200px; margin: auto">
        <!-- شاشة تحميل -->
        <div v-if="isLoading" class="loading-screen">
            <div class="spinner"></div>
            <p>جاري التحميل...</p>
        </div>

        <div class="new">
            <!-- الخطوة 1 -->
            <div v-if="step === 1">
                <h2 class="mb-4" style="color: #003366">المعلومات الشخصية</h2>
                <p style="color: green">رقم المناظرة : {{ userId }}</p>
                <br />
                <div class="row st1">
                    <!-- الاسم الكامل -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">الاسم الكامل *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="formData.fullName"
                            @blur="validateField('fullName')"
                        />
                        <small class="text-danger">{{ errors.fullName }}</small>
                    </div>

                    <!-- اسم الأب -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">اسم الأب *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="formData.fatherName"
                            @blur="validateField('fatherName')"
                        />
                        <small class="text-danger">{{
                            errors.fatherName
                        }}</small>
                    </div>

                    <!-- تاريخ الولادة -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">تاريخ الولادة *</label>
                        <input
                            type="date"
                            class="form-control"
                            v-model="formData.birthDate"
                            @blur="validateField('birthDate')"
                            :min="minDate"
                            :max="maxDate"
                        />
                        <small class="text-danger">{{
                            errors.birthDate
                        }}</small>
                    </div>

                    <!-- الجنس -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">الجنس *</label>
                        <select
                            class="form-control"
                            v-model="formData.sex"
                            @blur="validateField('sex')"
                        >
                            <option value="">اختر</option>
                            <option value="ذكر">ذكر</option>
                            <option value="أنثى">أنثى</option>
                        </select>
                        <small class="text-danger">{{ errors.sex }}</small>
                    </div>

                    <!-- مكان الولادة -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">مكان الولادة *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="formData.birthPlace"
                            @blur="validateField('birthPlace')"
                        />
                        <small class="text-danger">{{
                            errors.birthPlace
                        }}</small>
                    </div>

                    <!-- الولاية -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">الولاية *</label>
                        <select
                            class="form-control"
                            v-model="formData.governorate"
                            @blur="validateField('governorate')"
                        >
                            <option value="">اختر الولاية</option>
                            <option value="تونس">تونس</option>
                            <option value="أريانة">أريانة</option>
                            <option value="بن عروس">بن عروس</option>
                            <option value="منوبة">منوبة</option>
                            <option value="نابل">نابل</option>
                            <option value="زغوان">زغوان</option>
                            <option value="بنزرت">بنزرت</option>
                            <option value="باجة">باجة</option>
                            <option value="جندوبة">جندوبة</option>
                            <option value="الكاف">الكاف</option>
                            <option value="سليانة">سليانة</option>
                            <option value="سوسة">سوسة</option>
                            <option value="المنستير">المنستير</option>
                            <option value="المهدية">المهدية</option>
                            <option value="صفاقس">صفاقس</option>
                            <option value="القيروان">القيروان</option>
                            <option value="القصرين">القصرين</option>
                            <option value="سيدي بوزيد">سيدي بوزيد</option>
                            <option value="قفصة">قفصة</option>
                            <option value="توزر">توزر</option>
                            <option value="قبلي">قبلي</option>
                            <option value="قابس">قابس</option>
                            <option value="مدنين">مدنين</option>
                            <option value="تطاوين">تطاوين</option>
                        </select>
                        <small class="text-danger">{{
                            errors.governorate
                        }}</small>
                    </div>

                    <!-- رقم بطاقة التعريف -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">رقم بطاقة التعريف *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="formData.nationalId"
                            @blur="validateField('nationalId')"
                        />
                        <small class="text-danger">{{
                            errors.nationalId
                        }}</small>
                    </div>

                    <!-- تاريخ الإصدار -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">تاريخ الإصدار *</label>
                        <input
                            type="date"
                            :min="minIssueDate"
                            :max="maxIssueDate"
                            class="form-control"
                            v-model="formData.issueDate"
                            @blur="validateField('issueDate')"
                        />
                        <small class="text-danger">{{
                            errors.issueDate
                        }}</small>
                    </div>

                    <!-- العنوان -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">العنوان *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="formData.address"
                            @blur="validateField('address')"
                        />
                        <small class="text-danger">{{ errors.address }}</small>
                    </div>

                    <!-- الترقيم البريدي -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">الترقيم البريدي *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="formData.postalCode"
                            @blur="validateField('postalCode')"
                        />
                        <small class="text-danger">{{
                            errors.postalCode
                        }}</small>
                    </div>

                    <!-- رقم الهاتف -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label">رقم الهاتف *</label>
                        <input
                            type="text"
                            class="form-control"
                            v-model="formData.phone"
                            @blur="validateField('phone')"
                        />
                        <small class="text-danger">{{ errors.phone }}</small>
                    </div>

                    <!-- البريد الإلكتروني -->
                    <div class="col-md-6 mb-3">
                        <label class="form-label"
                            >البريد الإلكتروني (اختياري)</label
                        >
                        <input
                            type="email"
                            class="form-control"
                            v-model="formData.email"
                            @blur="validateField('email')"
                        />
                        <small class="text-danger">{{ errors.email }}</small>
                    </div>
                </div>

                <div class="mt-4">
                    <button
                        class="btn btn-secondary"
                        @click="$router.push('/')"
                    >
                        رجوع للرئيسية
                    </button>
                    <button class="btn btn-primary" @click="nextStep">
                        التالي
                    </button>
                </div>
            </div>

            <!-- الخطوة 2 -->
            <div v-if="step === 2">
                <h2 class="mb-4" style="color: #003366">
                    المعلومات الأكاديمية
                </h2>
                <p style="color: green">رقم المناظرة : {{ userId }}</p>
                <br />

                <div class="row st1">
                    <!-- إذا كان ID بين 25/01 و 25/14 -->

                    <div
                        v-if="
                            [
                                '25/01',
                                '25/02',
                                '25/03',
                                '25/04',
                                '25/05',
                                '25/06',
                                '25/07',
                                '25/08',
                                '25/09',
                                '25/10',
                                '25/11',
                                '25/12',
                                '25/13',
                                '25/14',
                            ].includes(userId)
                        "
                    >
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >شهادة البكالوريا *</label
                                >
                                <select
                                    class="form-control"
                                    v-model="formData.bacSpecialization"
                                    @blur="validateField('bacSpecialization')"
                                    required
                                >
                                    <option disabled value="">
                                        اختر الاختصاص
                                    </option>
                                    <option>علوم تقنية</option>
                                    <option>رياضيات</option>
                                    <option>اقتصاد و تصرف</option>
                                    <option>علوم تجريبية</option>
                                    <option>إعلامية</option>
                                    <option>رياضة</option>
                                    <option>آداب</option>
                                </select>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >المعدل النهائي لامتحان الباكالوريا *</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.bacScore"
                                    min="0"
                                    max="20"
                                    step="0.01"
                                    @blur="validateField('bacScore')"
                                    required
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >الشهادة العلمية المتحصَّل عليها*</label
                                >
                                <input
                                    class="form-control"
                                    v-model="formData.universityDegree"
                                    @blur="validateField('universityDegree')"
                                    required
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >المؤسسة الجامعية *</label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.university"
                                    @blur="validateField('university')"
                                    required
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label">سنة التخرج *</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.graduationYear"
                                    min="2000"
                                    max="2025"
                                    @blur="validateField('graduationYear')"
                                    required
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >معدل سنةالتخرج *</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.graduationScore"
                                    min="0"
                                    max="20"
                                    @blur="validateField('graduationScore')"
                                    required
                                    step="0.01"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- إذا كان ID = 25/15 -->
                    <div v-if="['25/15'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label">نوع الشهادة *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.diplomaType"
                                    @blur="validateField('diplomaType')"
                                    required
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option>بكالوريا</option>
                                    <option>مؤهل تقني مهني</option>
                                </select>
                            </div>

                            <!-- بكالوريا -->
                            <div
                                class="col-md-6 mb-3"
                                v-if="formData.diplomaType === 'بكالوريا'"
                            >
                                <label class="form-label"
                                    >اختصاص البكالوريا *</label
                                >
                                <select
                                    class="form-control"
                                    v-model="formData.bacSpecialization"
                                    @blur="validateField('bacSpecialization')"
                                    required
                                >
                                    <option disabled value="">
                                        اختر الاختصاص
                                    </option>
                                    <option>علوم تقنية</option>
                                    <option>رياضيات</option>
                                    <option>علوم تجريبية</option>
                                    <option>إعلامية</option>
                                    <option>رياضة</option>
                                </select>
                            </div>

                            <div
                                class="col-md-6 mb-3"
                                v-if="formData.diplomaType === 'بكالوريا'"
                            >
                                <label class="form-label"
                                    >المعدل النهائي *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.bacScore"
                                    min="0"
                                    max="20"
                                />
                            </div>

                            <!-- مؤهل تقني مهني -->
                            <div
                                v-if="formData.diplomaType === 'مؤهل تقني مهني'"
                            >
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">الاختصاص *</label>
                                    <select
                                        class="form-control"
                                        v-model="formData.techSpecialization"
                                        @blur="
                                            validateField('techSpecialization')
                                        "
                                        required
                                    >
                                        <option disabled value="">
                                            اختر الاختصاص
                                        </option>
                                        <option>إعلامية</option>
                                        <option>كهرباء</option>
                                        <option>آلات دقيقة</option>
                                        <option>ميكانيك</option>
                                        <option>إلكترو ميكانيك</option>
                                        <option>صيانة صناعية</option>
                                        <option>كهرباء صناعية</option>
                                        <option>إلكترونيك</option>
                                        <option>إلكتروتكنيك</option>
                                    </select>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >مؤسسة التكوين المهني*</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.trainingCenter"
                                        @blur="validateField('trainingCenter')"
                                    />
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >سنة الحصول على شهادة مؤهَّل تقني
                                        مهني*</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear"
                                        min="2000"
                                        max="2100"
                                    />
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >معدل الحصول على شهادة مؤهَّل تقني
                                        مهني*</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.techScore"
                                        min="0"
                                        max="20"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="['25/16'].includes(userId)">
                        <h2 class="mb-4">المؤهلات العلمية</h2>

                        <!-- شهادة الباكالوريا -->
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >اختصاص شهادة الباكالوريا *</label
                                >
                                <select
                                    class="form-control"
                                    v-model="formData.bacSpecialization"
                                    @blur="validateField('bacSpecialization')"
                                >
                                    <option disabled value="">
                                        اختر الاختصاص
                                    </option>
                                    <option>علوم تقنية</option>
                                    <option>رياضيات</option>
                                    <option>اقتصاد و تصرف</option>
                                    <option>علوم تجريبية</option>
                                    <option>إعلامية</option>
                                    <option>رياضة</option>
                                    <option>آداب</option>
                                </select>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >المعدل النهائي للباكالوريا *</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.bacScore"
                                    min="0"
                                    max="20"
                                    step="0.01"
                                />
                            </div>
                        </div>

                        <div class="col-md-6 mb-3">
                            <label class="form-label"
                                >نوع الشهادة العلمية *</label
                            >
                            <select
                                class="form-control"
                                v-model="formData.degreeType"
                                @change="validateField('degreeType')"
                            >
                                <option disabled value="">
                                    اختر نوع الشهادة
                                </option>
                                <option value="تقني سامي مساعد مديرية">
                                    تقني سامي اختصاص مساعد مديرية
                                </option>
                                <option value="شهادة معادلة">
                                    شهادة تُعادل الخطة المطلوبة
                                </option>
                            </select>
                        </div>

                        <!-- إذا كان المترشّح متحصّل على شهادة تقني سامي اختصاص مساعد مديرية -->
                        <div
                            v-if="
                                formData.degreeType === 'تقني سامي مساعد مديرية'
                            "
                        >
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >المؤسسة الجامعية *</label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.university"
                                    @blur="validateField('university')"
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label">سنة التخرج *</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.graduationYear"
                                    min="2000"
                                    max="2100"
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >معدل سنة التخرج *</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.graduationScore"
                                    step="0.01"
                                    min="0"
                                    max="20"
                                />
                            </div>
                        </div>

                        <!-- إذا كان المترشّح متحصّل على شهادة تعادل الخطة المطلوبة -->
                        <div v-if="formData.degreeType === 'شهادة معادلة'">
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >المؤسسة الجامعية *</label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.university"
                                    @blur="validateField('university')"
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >الشهادة المتحصّل عليها *</label
                                >
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.obtainedDegree"
                                    @blur="validateField('obtainedDegree')"
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label">سنة التخرج *</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.graduationYear"
                                    min="2000"
                                    max="2100"
                                />
                            </div>

                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >معدل سنة التخرج *</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.graduationScore"
                                    step="0.01"
                                    min="0"
                                    max="20"
                                />
                            </div>
                        </div>
                    </div>

                    <!-- إذا كان ID = 25/17 -->
                    <div v-if="['25/17'].includes(userId)">
                        <h2 class="mb-4">المؤهلات العلمية</h2>

                        <div class="row">
                            <!-- اختصاص الباكالوريا -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >اختصاص شهادة الباكالوريا *</label
                                >
                                <select
                                    class="form-control"
                                    v-model="formData.bacSpecialization17"
                                    @blur="validateField('bacSpecialization17')"
                                >
                                    <option disabled value="">
                                        اختر الاختصاص
                                    </option>
                                    <option>علوم تقنية</option>
                                    <option>رياضيات</option>
                                    <option>اقتصاد و تصرف</option>
                                    <option>علوم تجريبية</option>
                                    <option>إعلامية</option>
                                    <option>رياضة</option>
                                    <option>آداب</option>
                                </select>
                                <small class="text-danger">{{
                                    errors.bacSpecialization17
                                }}</small>
                            </div>

                            <!-- المعدل النهائي للباكالوريا -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >المعدل النهائي لامتحان الباكالوريا *</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.bacScore17"
                                    min="0"
                                    max="20"
                                    step="0.01"
                                    @blur="validateField('bacScore17')"
                                />
                                <small class="text-danger">{{
                                    errors.bacScore17
                                }}</small>
                            </div>

                            <!-- نوع الشهادة -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label">نوع الشهادة *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.degreeType17"
                                    @change="validateField('degreeType17')"
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option value="إجازة">
                                        متحصل على شهادة الإجازة
                                    </option>
                                    <option value="مؤهل تقني سامي في الكيمياء">
                                        متحصل على شهادة مؤهل تقني سامي في
                                        الكيمياء
                                    </option>
                                </select>
                                <small class="text-danger">{{
                                    errors.degreeType17
                                }}</small>
                            </div>

                            <!-- إذا اختار إجازة -->
                            <div v-if="formData.degreeType17 === 'إجازة'">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >المؤسسة الجامعية *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university17"
                                        @blur="validateField('university17')"
                                    />
                                    <small class="text-danger">{{
                                        errors.university17
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >الشهادة المتحصل عليها *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.obtainedDegree17"
                                        @blur="
                                            validateField('obtainedDegree17')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.obtainedDegree17
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear17"
                                        min="2000"
                                        max="2100"
                                        @blur="
                                            validateField('graduationYear17')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationYear17
                                    }}</small>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label class="form-label">
                                        معدل سنة التخرج*</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationScore17"
                                        min="0"
                                        max="20"
                                        step="0.01"
                                        @blur="
                                            validateField('graduationScore17')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationScore17
                                    }}</small>
                                </div>
                            </div>

                            <!-- إذا اختار مؤهل تقني سامي في الكيمياء -->
                            <div
                                v-if="
                                    formData.degreeType17 ===
                                    'مؤهل تقني سامي في الكيمياء'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >المؤسسة الجامعية *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.institution17"
                                        @blur="validateField('institution17')"
                                    />
                                    <small class="text-danger">{{
                                        errors.institution17
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear17"
                                        min="2000"
                                        max="2100"
                                        @blur="
                                            validateField('graduationYear17')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationYear17
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label">
                                        معدل سنة التخرج
                                    </label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationScore17"
                                        min="0"
                                        max="20"
                                        step="0.01"
                                        @blur="
                                            validateField('graduationScore17')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationScore17
                                    }}</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- إذا كان ID = 25/18 -->
                    <div v-if="['25/18'].includes(userId)">
                        <h2 class="mb-4">المؤهلات العلمية</h2>

                        <div class="row">
                            <!-- اختصاص الباكالوريا -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >اختصاص شهادة الباكالوريا *</label
                                >
                                <select
                                    class="form-control"
                                    v-model="formData.bacSpecialization18"
                                    @blur="validateField('bacSpecialization18')"
                                >
                                    <option disabled value="">
                                        اختر الاختصاص
                                    </option>
                                    <option>علوم تقنية</option>
                                    <option>رياضيات</option>
                                    <option>اقتصاد و تصرف</option>
                                    <option>علوم تجريبية</option>
                                    <option>إعلامية</option>
                                    <option>رياضة</option>
                                    <option>آداب</option>
                                </select>
                                <small class="text-danger">{{
                                    errors.bacSpecialization18
                                }}</small>
                            </div>

                            <!-- المعدل النهائي للباكالوريا -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >المعدل النهائي لامتحان الباكالوريا *</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.bacScore18"
                                    min="0"
                                    max="20"
                                    step="0.01"
                                    @blur="validateField('bacScore18')"
                                />
                                <small class="text-danger">{{
                                    errors.bacScore18
                                }}</small>
                            </div>

                            <!-- نوع الشهادة -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label">نوع الشهادة *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.degreeType18"
                                    @change="validateField('degreeType18')"
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option value="إجازة">
                                        متحصل على شهادة الإجازة
                                    </option>
                                    <option
                                        value="مؤهل تقني سامي في الهندسة الميكانيكية"
                                    >
                                        متحصل على شهادة مؤهل تقني سامي في
                                        الهندسة الميكانيكية
                                    </option>
                                </select>
                                <small class="text-danger">{{
                                    errors.degreeType18
                                }}</small>
                            </div>

                            <!-- إذا اختار إجازة -->
                            <div v-if="formData.degreeType18 === 'إجازة'">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >المؤسسة الجامعية *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university18"
                                        @blur="validateField('university18')"
                                    />
                                    <small class="text-danger">{{
                                        errors.university18
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >الشهادة المتحصل عليها *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.obtainedDegree18"
                                        @blur="
                                            validateField('obtainedDegree18')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.obtainedDegree18
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear18"
                                        min="2000"
                                        max="2100"
                                        @blur="
                                            validateField('graduationYear18')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationYear18
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >معدل سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationScore18"
                                        min="0"
                                        max="20"
                                        step="0.01"
                                        @blur="
                                            validateField('graduationScore18')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationScore18
                                    }}</small>
                                </div>
                            </div>

                            <!-- إذا اختار مؤهل تقني سامي في الهندسة الميكانيكية -->
                            <div
                                v-if="
                                    formData.degreeType18 ===
                                    'مؤهل تقني سامي في الهندسة الميكانيكية'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >المؤسسة الجامعية *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university18"
                                        @blur="validateField('university18')"
                                    />
                                    <small class="text-danger">{{
                                        errors.university18
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear18"
                                        min="2000"
                                        max="2100"
                                        @blur="
                                            validateField('graduationYear18')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationYear18
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >معدل سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationScore18"
                                        min="0"
                                        max="20"
                                        step="0.01"
                                        @blur="
                                            validateField('graduationScore18')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationScore18
                                    }}</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- إذا كان ID = 25/19 -->
                    <div v-if="['25/19'].includes(userId)">
                        <h2 class="mb-4">المؤهلات العلمية</h2>

                        <div class="row">
                            <!-- اختصاص الباكالوريا -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >اختصاص شهادة الباكالوريا *</label
                                >
                                <select
                                    class="form-control"
                                    v-model="formData.bacSpecialization19"
                                    @blur="validateField('bacSpecialization19')"
                                >
                                    <option disabled value="">
                                        اختر الاختصاص
                                    </option>
                                    <option>علوم تقنية</option>
                                    <option>رياضيات</option>
                                    <option>اقتصاد و تصرف</option>
                                    <option>علوم تجريبية</option>
                                    <option>إعلامية</option>
                                    <option>رياضة</option>
                                    <option>آداب</option>
                                </select>
                                <small class="text-danger">{{
                                    errors.bacSpecialization19
                                }}</small>
                            </div>

                            <!-- المعدل النهائي للباكالوريا -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label"
                                    >المعدل النهائي لامتحان الباكالوريا *</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.bacScore19"
                                    min="0"
                                    max="20"
                                    step="0.01"
                                    @blur="validateField('bacScore19')"
                                />
                                <small class="text-danger">{{
                                    errors.bacScore19
                                }}</small>
                            </div>

                            <!-- نوع الشهادة -->
                            <div class="col-md-6 mb-3">
                                <label class="form-label">نوع الشهادة *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.degreeType19"
                                    @change="validateField('degreeType19')"
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option>إجازة</option>
                                    <option>
                                        مؤهل تقني سامي في الهندسة الكهربائية
                                    </option>
                                </select>
                                <small class="text-danger">{{
                                    errors.degreeType19
                                }}</small>
                            </div>

                            <!-- إذا اختار إجازة -->
                            <div v-if="formData.degreeType19 === 'إجازة'">
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >المؤسسة الجامعية *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university19"
                                        @blur="validateField('university19')"
                                    />
                                    <small class="text-danger">{{
                                        errors.university19
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >الشهادة المتحصل عليها *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.obtainedDegree19"
                                        @blur="
                                            validateField('obtainedDegree19')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.obtainedDegree19
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear19"
                                        min="2000"
                                        max="2100"
                                        @blur="
                                            validateField('graduationYear19')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationYear19
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >معدل سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationScore19"
                                        min="0"
                                        max="20"
                                        step="0.01"
                                        @blur="
                                            validateField('graduationScore19')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationScore19
                                    }}</small>
                                </div>
                            </div>

                            <!-- إذا اختار مؤهل تقني سامي في الهندسة الكهربائية -->
                            <div
                                v-if="
                                    formData.degreeType19 ===
                                    'مؤهل تقني سامي في الهندسة الكهربائية'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >المؤسسة الجامعية *</label
                                    >
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university19"
                                        @blur="validateField('university19')"
                                    />
                                    <small class="text-danger">{{
                                        errors.university19
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear19"
                                        min="2000"
                                        max="2100"
                                        @blur="
                                            validateField('graduationYear19')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationYear19
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >معدل سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationScore19"
                                        min="0"
                                        max="20"
                                        step="0.01"
                                        @blur="
                                            validateField('graduationScore19')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationScore19
                                    }}</small>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="['25/20'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>اختصاص شهادة الباكالوريا *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.bacSpecialization20"
                                    @blur="validateField('bacSpecialization20')"
                                >
                                    <option disabled value="">
                                        اختر الاختصاص
                                    </option>
                                    <option>علوم تقنية</option>
                                    <option>رياضيات</option>
                                    <option>اقتصاد و تصرف</option>
                                    <option>علوم تجريبية</option>
                                    <option>إعلامية</option>
                                    <option>رياضة</option>
                                    <option>آداب</option></select
                                ><span class="text-danger">{{
                                    errors.bacSpecialization20
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>معدل الباكالوريا *</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.bacScore20"
                                    @blur="validateField('bacScore20')"
                                />
                                <span class="text-danger">{{
                                    errors.bacScore20
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>نوع الشهادة *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.degreeType20"
                                    @blur="validateField('degreeType20')"
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option>إجازة</option>
                                    <option>
                                        مؤهل تقني سامي في التصرف في الموارد
                                        البشرية
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.degreeType20
                                }}</span>
                            </div>

                            <!-- إذا إختار إجازة -->
                            <template v-if="formData.degreeType20 === 'إجازة'">
                                <div class="col-md-6 mb-3">
                                    <label>المؤسسة الجامعية *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university20"
                                        @blur="validateField('university20')"
                                    />
                                    <span class="text-danger">{{
                                        errors.university20
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>الشهادة المتحصل عليها *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.obtainedDegree20"
                                        @blur="
                                            validateField('obtainedDegree20')
                                        "
                                    />
                                    <span class="text-danger">{{
                                        errors.obtainedDegree20
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear20"
                                        min="2000"
                                        max="2100"
                                        @blur="
                                            validateField('graduationYear20')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationYear20
                                    }}</small>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label class="form-label"
                                        >معدل سنة التخرج *</label
                                    >
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationScore20"
                                        min="0"
                                        max="20"
                                        step="0.01"
                                        @blur="
                                            validateField('graduationScore20')
                                        "
                                    />
                                    <small class="text-danger">{{
                                        errors.graduationScore20
                                    }}</small>
                                </div>
                            </template>

                            <!-- إذا إختار مؤهل تقني -->
                            <template
                                v-if="
                                    formData.degreeType20 ===
                                    'مؤهل تقني سامي في التصرف في الموارد البشرية'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label>المؤسسة الجامعية *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university20"
                                        @blur="validateField('university20')"
                                    />
                                    <span class="text-danger">{{
                                        errors.university20
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>سنة التخرج *</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear20"
                                        min="2000"
                                        max="2100"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationYear20
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>معدل سنة التخرج *</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        class="form-control"
                                        v-model="formData.graduationScore20"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationScore20
                                    }}</span>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div v-if="['25/21'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>نوع شهادة الباكالوريا *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.bacType21"
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option>علمية تقنية</option>
                                    <option>رياضيات</option>
                                    <option>علوم تجريبية</option>
                                    <option>معلوماتية</option>
                                    <option>رياضة</option>
                                    <option>اقتصاد وإدارة</option>
                                    <option>آداب</option>
                                </select>
                                <span class="text-danger">{{
                                    errors.bacType21
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label
                                    >المعدل النهائي لامتحان الباكالوريا *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.bacScore21"
                                />
                                <span class="text-danger">{{
                                    errors.bacScore21
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>نوع الشهادة *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.degreeType21"
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option>إجازة</option>
                                    <option>
                                        مؤهّل تقني سامٍ في الإلكترونيك
                                        والكهروتقنية والآلية
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.degreeType21
                                }}</span>
                            </div>

                            <!-- إذا إختار إجازة -->
                            <template v-if="formData.degreeType21 === 'إجازة'">
                                <div class="col-md-6 mb-3">
                                    <label>المؤسسة الجامعية *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university21"
                                        @blur="validateField('university21')"
                                    />
                                    <span class="text-danger">{{
                                        errors.university21
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>الشهادة المتحصل عليها *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.obtainedDegree21"
                                        @blur="
                                            validateField('obtainedDegree21')
                                        "
                                    />
                                    <span class="text-danger">{{
                                        errors.obtainedDegree21
                                    }}</span>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label>سنة التخرج*</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear21"
                                        min="2000"
                                        max="2100"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationYear21
                                    }}</span>
                                </div>

                                <div class="col-md-6 mb-3">
                                    <label>معدل سنة التخرج *</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        class="form-control"
                                        v-model="formData.graduationScore21"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationScore21
                                    }}</span>
                                </div>
                            </template>

                            <!-- إذا إختار مؤهل تقني -->
                            <template
                                v-if="
                                    formData.degreeType21 ===
                                    'مؤهّل تقني سامٍ في الإلكترونيك والكهروتقنية والآلية'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label>المؤسسة الجامعية *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university21"
                                        @blur="validateField('university21')"
                                    />
                                    <span class="text-danger">{{
                                        errors.university21
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>سنة التخرج *</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear21"
                                        min="2000"
                                        max="2100"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationYear21
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>المعدل النهائي *</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        class="form-control"
                                        v-model="formData.graduationScore21"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationScore21
                                    }}</span>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div v-if="['25/22'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>نوع شهادة الباكالوريا *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.bacType22"
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option>علمية تقنية</option>
                                    <option>رياضيات</option>
                                    <option>علوم تجريبية</option>
                                    <option>معلوماتية</option>
                                    <option>رياضة</option>
                                    <option>اقتصاد وإدارة</option>
                                    <option>آداب</option>
                                </select>
                                <span class="text-danger">{{
                                    errors.bacType22
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label
                                    >المعدل النهائي لامتحان الباكالوريا *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.bacScore22"
                                />
                                <span class="text-danger">{{
                                    errors.bacScore22
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>نوع الشهادة *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.degreeType22"
                                >
                                    <option disabled value="">
                                        اختر نوع الشهادة
                                    </option>
                                    <option>إجازة</option>
                                    <option
                                        value="مؤهل تقني سامي في إدارة الأعمال: المحاسبة والمالية"
                                    >
                                        مؤهل تقني سامي في إدارة الأعمال: التصرف
                                        المحاسبي والمالي
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.degreeType22
                                }}</span>
                            </div>

                            <!-- إذا إختار إجازة -->
                            <template v-if="formData.degreeType22 === 'إجازة'">
                                <div class="col-md-6 mb-3">
                                    <label>المؤسسة الجامعية *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university22"
                                        @blur="validateField('university22')"
                                    />
                                    <span class="text-danger">{{
                                        errors.university22
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>الشهادة المتحصل عليها *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.obtainedDegree22"
                                        @blur="
                                            validateField('obtainedDegree22')
                                        "
                                    />
                                    <span class="text-danger">{{
                                        errors.obtainedDegree22
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>سنة التخرج *</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear22"
                                        min="2000"
                                        max="2100"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationYear22
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>معدل سنة التخرج *</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        class="form-control"
                                        v-model="formData.graduationScore22"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationScore22
                                    }}</span>
                                </div>
                            </template>

                            <!-- إذا إختار مؤهل تقني -->
                            <template
                                v-if="
                                    formData.degreeType22 ===
                                    'مؤهل تقني سامي في إدارة الأعمال: المحاسبة والمالية'
                                "
                            >
                                <div class="col-md-6 mb-3">
                                    <label>المؤسسة الجامعية *</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="formData.university22"
                                        @blur="validateField('university22')"
                                    />
                                    <span class="text-danger">{{
                                        errors.university22
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>سنة التخرج *</label>
                                    <input
                                        type="number"
                                        class="form-control"
                                        v-model="formData.graduationYear22"
                                        min="2000"
                                        max="2100"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationYear22
                                    }}</span>
                                </div>
                                <div class="col-md-6 mb-3">
                                    <label>معدل سنة التخرج *</label>
                                    <input
                                        type="number"
                                        step="0.01"
                                        class="form-control"
                                        v-model="formData.graduationScore22"
                                    />
                                    <span class="text-danger">{{
                                        errors.graduationScore22
                                    }}</span>
                                </div>
                            </template>
                        </div>
                    </div>

                    <div v-if="['25/23'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>شهادة مؤهل تقني مهني *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.techCert23"
                                    @blur="validateField('techCert23')"
                                />
                                <span class="text-danger">{{
                                    errors.techCert23
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>مؤسسة التكوين المهني *</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="formData.trainingCenter23"
                                    @blur="validateField('trainingCenter23')"
                                />
                                <span class="text-danger">{{
                                    errors.trainingCenter23
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>
                                    سنة الحصول على شهادة مؤهل تقني مهني*</label
                                >
                                <input
                                    type="number"
                                    class="form-control"
                                    v-model="formData.graduationYear23"
                                    min="2000"
                                    max="2100"
                                />
                                <span class="text-danger">{{
                                    errors.graduationYear23
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label
                                    >معدل الحصول على شهادة مؤهل تقني مهني
                                    *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.graduationScore23"
                                />
                                <span class="text-danger">{{
                                    errors.graduationScore23
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="['25/24'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>المستوى الدراسي *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.studyLevel24"
                                >
                                    <option value="">اختر المستوى</option>
                                    <option value="سنة تاسعة أساسي منهاة بنجاح">
                                        سنة 9 إعدادي منهاة بنجاح
                                    </option>
                                    <option
                                        value="السنة الأولى ثانوي منهاة بنجاح نظام جديد"
                                    >
                                        سنة 01 ثانوي منهاة بنجاح (نظام جديد)
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.studyLevel24
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label>المعدل النهائي للشهادة المدرسية *</label>
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.finalScore24"
                                />
                                <span class="text-danger">{{
                                    errors.finalScore24
                                }}</span>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label>الشهادة العسكرية *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.militaryCertOption24"
                                >
                                    <option value="">اختر</option>
                                    <option
                                        value="متحصّل على شهادة الخدمة العسكرية"
                                    >
                                        متحصل على شهادة الخدمة العسكرية
                                    </option>
                                    <option
                                        value="متحصّل على شهادة في إتمام الخدمة الوطنية وشهادة حسن السيرة"
                                    >
                                        متحصل على شهادة الخدمة العسكرية و حسن
                                        السيرة
                                    </option>
                                    <option value="لم أُجرِ الخدمة العسكرية">
                                        لم أجرِ الخدمة العسكرية
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.militaryCertOption24
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="['25/25', '25/26'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>المستوى الدراسي *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.studyLevel25_26"
                                >
                                    <option value="">اختر المستوى</option>
                                    <option
                                        value="السنة السادسة أساسي منهاة بنجاح"
                                    >
                                        سنة 6 أساسي منهاة بنجاح
                                    </option>
                                    <option
                                        value="السنة السابعة أساسي منهاة بنجاح"
                                    >
                                        سنة 7 أساسي منهاة بنجاح
                                    </option>
                                    <option
                                        value="السنة الثامنة أساسي منهاة بنجاح"
                                    >
                                        سنة 8 أساسي منهاة بنجاح
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.studyLevel25_26
                                }}</span>
                            </div>
                            <div class="col-md-6 mb-3">
                                <label
                                    >المعدل النهائي للنجاح بالشهادة المدرسية
                                    *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.finalScore25_26"
                                />
                                <span class="text-danger">{{
                                    errors.finalScore25_26
                                }}</span>
                            </div>
                            <div class="col-md-12 mb-3">
                                <label>الشهادة العسكرية *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.militaryCertOption25_26"
                                >
                                    <option value="">اختر</option>
                                    <option
                                        value="متحصّل على شهادة الخدمة العسكرية"
                                    >
                                        متحصل على شهادة الخدمة العسكرية
                                    </option>
                                    <option
                                        value="متحصّل على شهادة الخدمة العسكرية وشهادة حسن السيرة"
                                    >
                                        متحصل على شهادة الخدمة العسكرية و حسن
                                        السيرة
                                    </option>
                                    <option value="لم أُجرِ الخدمة العسكرية">
                                        لم أجرِ الخدمة العسكرية
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.militaryCertOption25_26
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="['25/27'].includes(userId)">
                        <div class="col-md-6 mb-3">
                            <label>المستوى الدراسي *</label>
                            <select
                                class="form-control"
                                v-model="formData.studyLevel25_27"
                            >
                                <option value="">اختر المستوى</option>
                                <option
                                    value="شهادة الكفاءة المهنية في اختصاص لحام"
                                >
                                    شهادة الكفاءة المهنية (CAP) في اختصاص اللحام
                                </option>
                                <option
                                    value="شهادة الكفاءة المهنية في اختصاص البناء المعدني"
                                >
                                    شهادة الكفاءة المهنية (CAP) في اختصاص البناء
                                    المعدني
                                </option>
                                <option
                                    value=" السنة الثانية ثانوي منهاة بنجاح نظام جديد"
                                >
                                    مستوى السنة الثانية ثانوي منهاة بنجاح (نظام
                                    جديد)
                                </option>
                            </select>
                            <span class="text-danger">{{
                                errors.studyLevel25_27
                            }}</span>
                        </div>

                        <div class="col-md-6 mb-3">
                            <label
                                >المعدل النهائي للنجاح بالشهادة المدرسية
                                *</label
                            >
                            <input
                                type="number"
                                step="0.01"
                                class="form-control"
                                v-model="formData.finalScore25_27"
                            />
                            <span class="text-danger">{{
                                errors.finalScore25_27
                            }}</span>
                        </div>

                        <div class="col-md-6 mb-3">
                            <label>شهائد التكوين المهني مع شهادة تنظير*</label>
                            <select
                                class="form-control"
                                v-model="formData.professionalWarning25_27"
                            >
                                <option value="">اختر</option>
                                <option value="نعم">نعم</option>
                                <option value="لا">لا</option>
                            </select>
                            <span class="text-danger">{{
                                errors.professionalWarning25_27
                            }}</span>
                        </div>
                    </div>

                    <div v-if="['25/28'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>المستوى الدراسي *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.studyLevel25_28"
                                >
                                    <option value="">اختر المستوى</option>
                                    <option
                                        value="شهادة الكفاءة المهنية في اختصاص الميكانيك"
                                    >
                                        شهادة الكفاءة المهنية (CAP) في اختصاص
                                        الميكانيك
                                    </option>
                                    <option
                                        value=" مستوى السنة الثانية ثانوي منهاة بنجاح نظام جديد"
                                    >
                                        مستوى السنة الثانية ثانوي منهاة بنجاح
                                        (نظام جديد)
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.studyLevel25_28
                                }}</span>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label
                                    >المعدل النهائي للنجاح بالشهادة المدرسية
                                    *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.finalScore25_28"
                                />
                                <span class="text-danger">{{
                                    errors.finalScore25_28
                                }}</span>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label
                                    >شهائد التكوين المهني مع شهادة تنظير*</label
                                >
                                <select
                                    class="form-control"
                                    v-model="formData.professionalWarning25_28"
                                >
                                    <option value="">اختر</option>
                                    <option value="نعم">نعم</option>
                                    <option value="لا">لا</option>
                                </select>
                                <span class="text-danger">{{
                                    errors.professionalWarning25_28
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="['25/29'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label>المستوى الدراسي *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.studyLevel25_29"
                                >
                                    <option value="">اختر المستوى</option>
                                    <option
                                        value="شهادة الكفاءة المهنية في اختصاص الكهربائي"
                                    >
                                        شهادة الكفاءة المهنية (CAP) في اختصاص
                                        الكهربائي
                                    </option>
                                    <option
                                        value="مستوى السنة الثانية ثانوي منهاة بنجاح (نظام جديد)"
                                    >
                                        مستوى السنة الثانية ثانوي منهاة بنجاح
                                        (نظام جديد)
                                    </option>
                                </select>
                                <span class="text-danger">{{
                                    errors.studyLevel25_29
                                }}</span>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label
                                    >المعدل النهائي للنجاح بالشهادة المدرسية
                                    *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.finalScore25_29"
                                />
                                <span class="text-danger">{{
                                    errors.finalScore25_29
                                }}</span>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label
                                    >شهائد التكوين المهني مع شهادة تنظير*</label
                                >
                                <select
                                    class="form-control"
                                    v-model="formData.professionalWarning25_29"
                                >
                                    <option value="">اختر</option>
                                    <option value="نعم">نعم</option>
                                    <option value="لا">لا</option>
                                </select>
                                <span class="text-danger">{{
                                    errors.professionalWarning25_29
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="
                            ['25/30', '25/31', '25/32', '25/33'].includes(
                                userId,
                            )
                        "
                    >
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label
                                    >المعدل النهائي للنجاح بالشهادة المدرسية
                                    *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.finalScore25_30_33"
                                />
                                <span class="text-danger">{{
                                    errors.finalScore25_30_33
                                }}</span>
                            </div>
                        </div>
                    </div>

                    <div v-if="['25/34', '25/35'].includes(userId)">
                        <div class="row">
                            <div class="col-md-6 mb-3">
                                <label
                                    >المعدل النهائي للنجاح بالشهادة المدرسية
                                    *</label
                                >
                                <input
                                    type="number"
                                    step="0.01"
                                    class="form-control"
                                    v-model="formData.finalScore25_34_35"
                                />
                                <span class="text-danger">{{
                                    errors.finalScore25_34_35
                                }}</span>
                            </div>

                            <div class="col-md-6 mb-3">
                                <label>متحصل على رخصة سياقة B+C+D *</label>
                                <select
                                    class="form-control"
                                    v-model="formData.drivingLicense25_34_35"
                                >
                                    <option value="">اختر</option>
                                    <option value="نعم">نعم</option>
                                    <option value="لا">لا</option>
                                </select>
                                <span class="text-danger">{{
                                    errors.drivingLicense25_34_35
                                }}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-4">
                    <button class="btn btn-secondary" @click="prevStep">
                        السابق
                    </button>
                    <button class="btn btn-primary" @click="nextStep">
                        تسجيل
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ConcoursService from "@/services/concoursService";
export default {
    data() {
        return {
            isLoading: false,
            step: 1,
            totalSteps: 2,
            userId: null,
            formData: {
                // Step 1
                fullName: "",
                fatherName: "",
                birthDate: "",
                sex: "",
                birthPlace: "",
                governorate: "",
                nationalId: "",
                issueDate: "",
                address: "",
                postalCode: "",
                phone: "",
                email: "",

                // Step 2
                bacSpecialization: "",
                bacScore: "",
                universityDegree: "",
                university: "",
                obtainedDegree: "",
                graduationYear: "",
                graduationScore: "",
                diplomaType: "",
                techSpecialization: "",
                trainingCenter: "",
                techScore: "",
                degreeType: "",

                bacSpecialization17: "",
                bacScore17: "",
                degreeType17: "",
                university17: "",
                obtainedDegree17: "",
                institution17: "",
                graduationYear17: "",
                graduationScore17: "",

                bacSpecialization18: "",
                bacScore18: "",
                degreeType18: "",
                university18: "",
                obtainedDegree18: "",
                graduationYear18: "",
                graduationScore18: "",

                bacSpecialization19: "",
                bacScore19: "",
                degreeType19: "",
                university19: "",
                obtainedDegree19: "",
                graduationYear19: "",
                graduationScore19: "",

                bacSpecialization20: "",
                bacScore20: "",
                degreeType20: "",
                university20: "",
                obtainedDegree20: "",
                graduationYear20: "",
                graduationScore20: "",

                bacType21: "",
                bacScore21: "",
                degreeType21: "",
                university21: "",
                obtainedDegree21: "",
                graduationYear21: "",
                graduationScore21: "",

                bacType22: "",
                bacScore22: "",
                degreeType22: "",
                university22: "",
                obtainedDegree22: "",
                graduationYear22: "",
                graduationScore22: "",

                techCert23: "",
                trainingCenter23: "",
                graduationYear23: "",
                graduationScore23: "",

                studyLevel24: "",
                finalScore24: "",
                militaryCertOption24: "",

                studyLevel25_26: "",
                finalScore25_26: "",
                militaryCertOption25_26: "",

                studyLevel25_27: "",
                finalScore25_27: "",
                professionalWarning25_27: "",

                studyLevel25_28: "",
                finalScore25_28: "",
                professionalWarning25_28: "",

                studyLevel25_29: "",
                finalScore25_29: "",
                professionalWarning25_29: "",

                finalScore25_30_33: "",
                finalScore25_34_35: "",
                drivingLicense25_34_35: "",
            },
            errors: {
                fullName: "",
                fatherName: "",
                birthDate: "",
                sex: "",
                birthPlace: "",
                governorate: "",
                nationalId: "",
                issueDate: "",
                address: "",
                postalCode: "",
                phone: "",
                email: "",

                bacSpecialization: "",
                bacScore: "",
                university: "",
                obtainedDegree: "",
                graduationYear: "",
                graduationScore: "",
                diplomaType: "",
                techSpecialization: "",
                trainingCenter: "",
                techScore: "",
                degreeType: "",

                bacSpecialization17: "",
                bacScore17: "",
                degreeType17: "",
                university17: "",
                obtainedDegree17: "",
                institution17: "",
                graduationYear17: "",
                graduationScore17: "",

                bacSpecialization18: "",
                bacScore18: "",
                degreeType18: "",
                university18: "",
                obtainedDegree18: "",
                graduationYear18: "",
                graduationScore18: "",

                bacSpecialization19: "",
                bacScore19: "",
                degreeType19: "",
                university19: "",
                obtainedDegree19: "",
                graduationYear19: "",
                graduationScore19: "",

                bacSpecialization20: "",
                bacScore20: "",
                degreeType20: "",
                university20: "",
                obtainedDegree20: "",
                graduationYear20: "",
                graduationScore20: "",

                bacType21: "",
                bacScore21: "",
                degreeType21: "",
                university21: "",
                obtainedDegree21: "",
                graduationYear21: "",
                graduationScore21: "",

                bacType22: "",
                bacScore22: "",
                degreeType22: "",
                university22: "",
                obtainedDegree22: "",
                graduationYear22: "",
                graduationScore22: "",

                techCert23: "",
                trainingCenter23: "",
                graduationYear23: "",
                graduationScore23: "",

                studyLevel24: "",
                finalScore24: "",
                militaryCertOption24: "",

                studyLevel25_26: "",
                finalScore25_26: "",
                militaryCertOption25_26: "",

                studyLevel25_27: "",
                finalScore25_27: "",
                professionalWarning25_27: "",

                studyLevel25_28: "",
                finalScore25_28: "",
                professionalWarning25_28: "",

                studyLevel25_29: "",
                finalScore25_29: "",

                professionalWarning25_29: "",

                finalScore25_30_33: "",
                finalScore25_34_35: "",
                drivingLicense25_34_35: "",
            },
            minDate: "",
            maxDate: "",
            minIssueDate: "",
            maxIssueDate: "",
        };
    },

    methods: {
        setDateLimits() {
            const today = new Date();
            const minIssueDate = new Date(
                today.getFullYear() - 50,
                today.getMonth(),
                today.getDate(),
            );
            const maxIssueDate = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate(),
            );
            const minDate = new Date(
                today.getFullYear() - 55,
                today.getMonth(),
                today.getDate(),
            );
            const maxDate = new Date(
                today.getFullYear() - 18,
                today.getMonth(),
                today.getDate(),
            );
            this.minIssueDate = minIssueDate.toISOString().split("T")[0];
            this.maxIssueDate = maxIssueDate.toISOString().split("T")[0];
            this.minDate = minDate.toISOString().split("T")[0];
            this.maxDate = maxDate.toISOString().split("T")[0];
        },
        validateField(field) {
            switch (field) {
                // Step 1 validation
                case "fullName":
                    if (!this.formData.fullName) {
                        this.errors.fullName = "الاسم واللقب مطلوب";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.fullName)
                    ) {
                        this.errors.fullName =
                            "يجب إدخال الاسم باللغة العربية فقط";
                    } else {
                        this.errors.fullName = "";
                    }
                    break;

                case "fatherName":
                    if (!this.formData.fatherName) {
                        this.errors.fatherName = "اسم الأب مطلوب";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.fatherName)
                    ) {
                        this.errors.fatherName =
                            "يجب إدخال الاسم باللغة العربية فقط";
                    } else {
                        this.errors.fatherName = "";
                    }
                    break;

                case "birthDate":
                    this.errors.birthDate = this.formData.birthDate
                        ? ""
                        : "تاريخ الولادة مطلوب";
                    break;

                case "sex":
                    this.errors.sex = this.formData.sex ? "" : "الجنس مطلوب";
                    break;

                case "birthPlace":
                    if (!this.formData.birthPlace) {
                        this.errors.birthPlace = "مكان الولادة مطلوب";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.birthPlace)
                    ) {
                        this.errors.birthPlace =
                            "يجب أن يكون مكان الولادة بالعربية فقط";
                    } else {
                        this.errors.birthPlace = "";
                    }
                    break;

                case "governorate":
                    this.errors.governorate = this.formData.governorate
                        ? ""
                        : "الولاية مطلوبة";
                    break;

                case "nationalId":
                    if (!this.formData.nationalId) {
                        this.errors.nationalId = "رقم بطاقة التعريف مطلوب";
                    } else if (!/^[0-9]{8}$/.test(this.formData.nationalId)) {
                        this.errors.nationalId = "يجب أن يكون 8 أرقام";
                    } else {
                        this.errors.nationalId = "";
                    }
                    break;

                case "issueDate":
                    this.errors.issueDate = this.formData.issueDate
                        ? ""
                        : "تاريخ الإصدار مطلوب";
                    break;

                case "address":
                    if (!this.formData.address) {
                        this.errors.address = "العنوان مطلوب";
                    } else if (
                        !/^[\u0600-\u06FF0-9\s]+$/.test(this.formData.address)
                    ) {
                        this.errors.address =
                            "العنوان يجب أن يكون بالعربية فقط";
                    } else {
                        this.errors.address = "";
                    }
                    break;

                case "postalCode":
                    this.errors.postalCode = this.formData.postalCode
                        ? ""
                        : "الترقيم البريدي مطلوب";
                    break;

                case "phone":
                    if (!this.formData.phone) {
                        this.errors.phone = "رقم الهاتف مطلوب";
                    } else if (!/^[0-9+\-\s]+$/.test(this.formData.phone)) {
                        this.errors.phone = "رقم الهاتف غير صالح";
                    } else {
                        this.errors.phone = "";
                    }
                    break;

                case "email":
                    if (
                        this.formData.email &&
                        !/\S+@\S+\.\S+/.test(this.formData.email)
                    ) {
                        this.errors.email = "البريد الإلكتروني غير صالح";
                    } else {
                        this.errors.email = "";
                    }
                    break;

                // Step 2 validation
                case "bacSpecialization":
                    if (!this.formData.bacSpecialization) {
                        this.errors.bacSpecialization =
                            "اختصاص البكالوريا مطلوب";
                    } else {
                        this.errors.bacSpecialization = "";
                    }
                    break;
                case "bacScore":
                    if (!this.formData.bacScore) {
                        this.errors.bacScore =
                            "المعدل النهائي للباكالوريا مطلوب";
                    } else if (!/^\d+(\.\d+)?$/.test(this.formData.bacScore)) {
                        this.errors.bacScore = "يُرجى إدخال رقم صالح";
                    } else {
                        this.errors.bacScore = "";
                    }
                    break;
                case "university":
                    if (!this.formData.university) {
                        this.errors.university = "المؤسسة الجامعية مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.university)
                    ) {
                        this.errors.university = "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.university = "";
                    }
                    break;

                case "obtainedDegree":
                    this.errors.obtainedDegree = this.formData.obtainedDegree
                        ? ""
                        : "اسم الشهادة مطلوب";
                    break;
                case "graduationYear":
                    this.errors.graduationYear = this.formData.graduationYear
                        ? ""
                        : "سنة التخرج مطلوبة";
                    break;
                case "graduationScore":
                    this.errors.graduationScore = this.formData.graduationScore
                        ? ""
                        : "معدل سنة التخرج مطلوب";
                    break;
                case "diplomaType":
                    this.errors.diplomaType = this.formData.diplomaType
                        ? ""
                        : "نوع الشهادة مطلوب";
                    break;
                case "techSpecialization":
                    this.errors.techSpecialization = this.formData
                        .techSpecialization
                        ? ""
                        : "الاختصاص مطلوب";
                    break;
                case "trainingCenter":
                    if (!this.formData.trainingCenter) {
                        this.errors.trainingCenter = "مؤسسة التكوين مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(
                            this.formData.trainingCenter,
                        )
                    ) {
                        this.errors.trainingCenter =
                            "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.trainingCenter = "";
                    }
                    break;

                case "techScore":
                    this.errors.techScore = this.formData.techScore
                        ? ""
                        : "المعدل مطلوب";
                    break;
                case "degreeType":
                    this.errors.degreeType = this.formData.degreeType
                        ? ""
                        : "نوع الشهادة العلمية مطلوب";
                    break;

                // Validation for ID 25/17
                case "bacSpecialization17":
                    this.errors.bacSpecialization17 = this.formData
                        .bacSpecialization17
                        ? ""
                        : "اختصاص الباكالوريا مطلوب";
                    break;
                case "bacScore17":
                    this.errors.bacScore17 = this.formData.bacScore17
                        ? ""
                        : "المعدل النهائي للباكالوريا مطلوب";
                    break;
                case "degreeType17":
                    this.errors.degreeType17 = this.formData.degreeType17
                        ? ""
                        : "نوع الشهادة مطلوب";
                    break;
                case "university17":
                    if (!this.formData.university17) {
                        this.errors.university17 = "المؤسسة الجامعية مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.university17)
                    ) {
                        this.errors.university17 = "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.university17 = "";
                    }
                    break;

                case "obtainedDegree17":
                    this.errors.obtainedDegree17 = this.formData
                        .obtainedDegree17
                        ? ""
                        : "الشهادة المطلوبة مطلوبة";
                    break;
                case "institution17":
                    if (!this.formData.institution17) {
                        this.errors.institution17 = "المؤسسة مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(
                            this.formData.institution17,
                        )
                    ) {
                        this.errors.institution17 =
                            "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.institution17 = "";
                    }
                    break;

                case "graduationYear17":
                    this.errors.graduationYear17 = this.formData
                        .graduationYear17
                        ? ""
                        : "سنة التخرج مطلوبة";
                    break;
                case "graduationScore17":
                    this.errors.graduationScore17 = this.formData
                        .graduationScore17
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;

                // Validation for ID 25/18
                case "bacSpecialization18":
                    this.errors.bacSpecialization18 = this.formData
                        .bacSpecialization18
                        ? ""
                        : "اختصاص الباكالوريا مطلوب";
                    break;
                case "bacScore18":
                    this.errors.bacScore18 = this.formData.bacScore18
                        ? ""
                        : "المعدل النهائي للباكالوريا مطلوب";
                    break;
                case "degreeType18":
                    this.errors.degreeType18 = this.formData.degreeType18
                        ? ""
                        : "نوع الشهادة مطلوب";
                    break;
                case "university18":
                    if (!this.formData.university18) {
                        this.errors.university18 = "المؤسسة الجامعية مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.university18)
                    ) {
                        this.errors.university18 = "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.university18 = "";
                    }
                    break;

                case "obtainedDegree18":
                    this.errors.obtainedDegree18 = this.formData
                        .obtainedDegree18
                        ? ""
                        : "الشهادة المتحصل عليها مطلوبة";
                    break;
                case "graduationYear18":
                    this.errors.graduationYear18 = this.formData
                        .graduationYear18
                        ? ""
                        : "سنة التخرج مطلوبة";
                    break;
                case "graduationScore18":
                    this.errors.graduationScore18 = this.formData
                        .graduationScore18
                        ? ""
                        : "معدل سنة التخرج مطلوب";
                    break;

                // Validation for ID 25/19
                case "bacSpecialization19":
                    this.errors.bacSpecialization19 = this.formData
                        .bacSpecialization19
                        ? ""
                        : "اختصاص الباكالوريا مطلوب";
                    break;
                case "bacScore19":
                    this.errors.bacScore19 = this.formData.bacScore19
                        ? ""
                        : "المعدل النهائي للباكالوريا مطلوب";
                    break;
                case "degreeType19":
                    this.errors.degreeType19 = this.formData.degreeType19
                        ? ""
                        : "نوع الشهادة مطلوب";
                    break;
                case "university19":
                    if (!this.formData.university19) {
                        this.errors.university19 = "المؤسسة الجامعية مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.university19)
                    ) {
                        this.errors.university19 = "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.university19 = "";
                    }
                    break;
                case "obtainedDegree19":
                    this.errors.obtainedDegree19 = this.formData
                        .obtainedDegree19
                        ? ""
                        : "الشهادة المتحصل عليها مطلوبة";
                    break;
                case "graduationYear19":
                    this.errors.graduationYear19 = this.formData
                        .graduationYear19
                        ? ""
                        : "سنة التخرج مطلوبة";
                    break;
                case "graduationScore19":
                    this.errors.graduationScore19 = this.formData
                        .graduationScore19
                        ? ""
                        : "معدل سنة التخرج مطلوب";
                    break;

                // Validation for ID 25/20
                case "bacSpecialization20":
                    this.errors.bacSpecialization20 = this.formData
                        .bacSpecialization20
                        ? ""
                        : "اختصاص الباكالوريا مطلوب";
                    break;
                case "bacScore20":
                    this.errors.bacScore20 = this.formData.bacScore20
                        ? ""
                        : "المعدل النهائي للباكالوريا مطلوب";
                    break;
                case "degreeType20":
                    this.errors.degreeType20 = this.formData.degreeType20
                        ? ""
                        : "نوع الشهادة مطلوب";
                    break;
                case "university20":
                    if (!this.formData.university20) {
                        this.errors.university20 = "المؤسسة الجامعية مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF0-9\s]+$/.test(
                            this.formData.university20,
                        )
                    ) {
                        this.errors.university20 = "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.university20 = "";
                    }
                    break;
                case "obtainedDegree20":
                    if (!this.formData.obtainedDegree20) {
                        this.errors.obtainedDegree20 =
                            "اسم الشهادة المطلوبة مطلوب";
                    } else if (
                        !/^[\u0600-\u06FF0-9\s]+$/.test(
                            this.formData.obtainedDegree20,
                        )
                    ) {
                        this.errors.obtainedDegree20 =
                            "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.obtainedDegree20 = "";
                    }
                    break;
                case "graduationYear20":
                    this.errors.graduationYear20 = this.formData
                        .graduationYear20
                        ? ""
                        : "سنة التخرج مطلوبة";
                    break;
                case "graduationScore20":
                    this.errors.graduationScore20 = this.formData
                        .graduationScore20
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;

                // Validation for ID 25/21
                case "bacType21":
                    this.errors.bacType21 = this.formData.bacType21
                        ? ""
                        : "نوع شهادة الباكالوريا مطلوب";
                    break;
                case "bacScore21":
                    this.errors.bacScore21 = this.formData.bacScore21
                        ? ""
                        : "المعدل النهائي للباكالوريا مطلوب";
                    break;
                case "degreeType21":
                    this.errors.degreeType21 = this.formData.degreeType21
                        ? ""
                        : "نوع الشهادة مطلوب";
                    break;
                case "university21":
                    if (!this.formData.university21) {
                        this.errors.university21 = "المؤسسة الجامعية مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.university21)
                    ) {
                        this.errors.university21 = "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.university21 = "";
                    }
                    break;
                case "obtainedDegree21":
                    this.errors.obtainedDegree21 = this.formData
                        .obtainedDegree21
                        ? ""
                        : "اسم الشهادة المطلوبة مطلوب";
                    break;
                case "graduationYear21":
                    this.errors.graduationYear21 = this.formData
                        .graduationYear21
                        ? ""
                        : "سنة التخرج مطلوبة";
                    break;
                case "graduationScore21":
                    this.errors.graduationScore21 = this.formData
                        .graduationScore21
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;

                // Validation for ID 25/22
                case "bacType22":
                    this.errors.bacType22 = this.formData.bacType22
                        ? ""
                        : "نوع شهادة الباكالوريا مطلوب";
                    break;
                case "bacScore22":
                    this.errors.bacScore22 = this.formData.bacScore22
                        ? ""
                        : "المعدل النهائي للباكالوريا مطلوب";
                    break;
                case "degreeType22":
                    this.errors.degreeType22 = this.formData.degreeType22
                        ? ""
                        : "نوع الشهادة مطلوب";
                    break;
                case "university22":
                    if (!this.formData.university22) {
                        this.errors.university22 = "المؤسسة الجامعية مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.university22)
                    ) {
                        this.errors.university22 = "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.university22 = "";
                    }
                    break;
                case "obtainedDegree22":
                    this.errors.obtainedDegree22 = this.formData
                        .obtainedDegree22
                        ? ""
                        : "اسم الشهادة المطلوبة مطلوب";
                    break;
                case "graduationYear22":
                    this.errors.graduationYear22 = this.formData
                        .graduationYear22
                        ? ""
                        : "سنة التخرج مطلوبة";
                    break;
                case "graduationScore22":
                    this.errors.graduationScore22 = this.formData
                        .graduationScore22
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;

                // Validation for ID 25/23
                case "techCert23":
                    if (!this.formData.techCert23) {
                        this.errors.techCert23 = "نوع الشهادة المهنية مطلوب";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(this.formData.techCert23)
                    ) {
                        this.errors.techCert23 = "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.techCert23 = "";
                    }
                    break;
                case "trainingCenter23":
                    if (!this.formData.trainingCenter23) {
                        this.errors.trainingCenter23 = "المؤسسة المهنية مطلوبة";
                    } else if (
                        !/^[\u0600-\u06FF\s]+$/.test(
                            this.formData.trainingCenter23,
                        )
                    ) {
                        this.errors.trainingCenter23 =
                            "يُرجى الكتابة بالعربية فقط";
                    } else {
                        this.errors.trainingCenter23 = "";
                    }
                    break;
                case "graduationYear23":
                    this.errors.graduationYear23 = this.formData
                        .graduationYear23
                        ? ""
                        : "سنة الحصول على الشهادة مطلوبة";
                    break;
                case "graduationScore23":
                    this.errors.graduationScore23 = this.formData
                        .graduationScore23
                        ? ""
                        : "المعدل النهائي للشهادة مطلوب";
                    break;

                // Validation for ID 25/24
                case "studyLevel24":
                    this.errors.studyLevel24 = this.formData.studyLevel24
                        ? ""
                        : "اختر المستوى الدراسي";
                    break;
                case "finalScore24":
                    this.errors.finalScore24 = this.formData.finalScore24
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;
                case "militaryCertOption24":
                    this.errors.militaryCertOption24 = this.formData
                        .militaryCertOption24
                        ? ""
                        : "اختر نوع الشهادة العسكرية";
                    break;

                // Validation for ID 25/25-26
                case "studyLevel25_26":
                    this.errors.studyLevel25_26 = this.formData.studyLevel25_26
                        ? ""
                        : "اختر المستوى الدراسي";
                    break;
                case "finalScore25_26":
                    this.errors.finalScore25_26 = this.formData.finalScore25_26
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;
                case "militaryCertOption25_26":
                    this.errors.militaryCertOption25_26 = this.formData
                        .militaryCertOption25_26
                        ? ""
                        : "اختر نوع الشهادة العسكرية";
                    break;

                // Validation for ID 25/27
                case "studyLevel25_27":
                    this.errors.studyLevel25_27 = this.formData.studyLevel25_27
                        ? ""
                        : "اختر المستوى الدراسي";
                    break;
                case "finalScore25_27":
                    this.errors.finalScore25_27 = this.formData.finalScore25_27
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;
                case "professionalWarning25_27":
                    this.errors.professionalWarning25_27 = this.formData
                        .professionalWarning25_27
                        ? ""
                        : "اختر هل يوجد تنبيه أم لا";
                    break;

                // Validation for ID 25/28
                case "studyLevel25_28":
                    this.errors.studyLevel25_28 = this.formData.studyLevel25_28
                        ? ""
                        : "اختر المستوى الدراسي";
                    break;
                case "finalScore25_28":
                    this.errors.finalScore25_28 = this.formData.finalScore25_28
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;

                case "professionalWarning25_28":
                    this.errors.professionalWarning25_28 = this.formData
                        .professionalWarning25_28
                        ? ""
                        : "اختر هل يوجد تنبيه أم لا";
                    break;

                // Validation for ID 25/29
                case "studyLevel25_29":
                    this.errors.studyLevel25_29 = this.formData.studyLevel25_29
                        ? ""
                        : "اختر المستوى الدراسي";
                    break;
                case "finalScore25_29":
                    this.errors.finalScore25_29 = this.formData.finalScore25_29
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;

                case "professionalWarning25_29":
                    this.errors.professionalWarning25_29 = this.formData
                        .professionalWarning25_29
                        ? ""
                        : "اختر هل يوجد تنبيه أم لا";
                    break;

                // Validation for ID 25/30-33
                case "finalScore25_30_33":
                    this.errors.finalScore25_30_33 = this.formData
                        .finalScore25_30_33
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;

                // Validation for ID 25/34-35
                case "finalScore25_34_35":
                    this.errors.finalScore25_34_35 = this.formData
                        .finalScore25_34_35
                        ? ""
                        : "المعدل النهائي مطلوب";
                    break;
                case "drivingLicense25_34_35":
                    this.errors.drivingLicense25_34_35 = this.formData
                        .drivingLicense25_34_35
                        ? ""
                        : "اختيار رخصة السياقة مطلوب";
                    break;
            }

            // حفظ البيانات بعد كل validation
            this.saveToLocalStorage();
        },

        validateStep1() {
            const step1Fields = [
                "fullName",
                "fatherName",
                "birthDate",
                "sex",
                "birthPlace",
                "governorate",
                "nationalId",
                "issueDate",
                "address",
                "postalCode",
                "phone",
                "email",
            ];
            step1Fields.forEach((field) => this.validateField(field));

            return step1Fields.every((field) => !this.errors[field]);
        },

        validateStep2() {
            let fieldsToValidate = [];

            // تحديد الحقول المطلوب validation حسب userId
            if (
                [
                    "25/01",
                    "25/02",
                    "25/03",
                    "25/04",
                    "25/05",
                    "25/06",
                    "25/07",
                    "25/08",
                    "25/09",
                    "25/10",
                    "25/11",
                    "25/12",
                    "25/13",
                    "25/14",
                ].includes(this.userId)
            ) {
                fieldsToValidate = [
                    "bacSpecialization",
                    "bacScore",
                    "university",
                    "graduationYear",
                    "graduationScore",
                ];
            } else if (["25/15"].includes(this.userId)) {
                fieldsToValidate = ["diplomaType"];
                if (this.formData.diplomaType === "بكالوريا") {
                    fieldsToValidate.push("bacSpecialization", "bacScore");
                }
                if (this.formData.diplomaType === "مؤهل تقني مهني") {
                    fieldsToValidate.push(
                        "techSpecialization",
                        "trainingCenter",
                        "graduationYear",
                        "techScore",
                    );
                }
            } else if (["25/16"].includes(this.userId)) {
                fieldsToValidate = [
                    "bacSpecialization",
                    "bacScore",
                    "degreeType",
                ];
                if (this.formData.degreeType) {
                    fieldsToValidate.push(
                        "university",
                        "graduationYear",
                        "graduationScore",
                    );
                    if (this.formData.degreeType === "شهادة معادلة") {
                        fieldsToValidate.push("obtainedDegree");
                    }
                }
            } else if (["25/17"].includes(this.userId)) {
                fieldsToValidate = [
                    "bacSpecialization17",
                    "bacScore17",
                    "degreeType17",
                ];
                if (this.formData.degreeType17 === "إجازة") {
                    fieldsToValidate.push(
                        "university17",
                        "obtainedDegree17",
                        "graduationScore17",
                    );
                } else if (
                    this.formData.degreeType17 === "مؤهل تقني سامي في الكيمياء"
                ) {
                    fieldsToValidate.push(
                        "institution17",
                        "graduationYear17",
                        "graduationScore17",
                    );
                }
            } else if (["25/18"].includes(this.userId)) {
                fieldsToValidate = [
                    "bacSpecialization18",
                    "bacScore18",
                    "degreeType18",
                ];
                if (this.formData.degreeType18 === "إجازة") {
                    fieldsToValidate.push(
                        "university18",
                        "obtainedDegree18",
                        "graduationYear18",
                        "graduationScore18",
                    );
                } else if (
                    this.formData.degreeType18 ===
                    "مؤهل تقني سامي في الهندسة الميكانيكية"
                ) {
                    fieldsToValidate.push(
                        "university18",
                        "graduationYear18",
                        "graduationScore18",
                    );
                }
            } else if (["25/19"].includes(this.userId)) {
                fieldsToValidate = [
                    "bacSpecialization19",
                    "bacScore19",
                    "degreeType19",
                ];
                if (this.formData.degreeType19 === "إجازة") {
                    fieldsToValidate.push(
                        "university19",
                        "obtainedDegree19",
                        "graduationYear19",
                        "graduationScore19",
                    );
                } else if (
                    this.formData.degreeType19 ===
                    "مؤهل تقني سامي في الهندسة الكهربائية"
                ) {
                    fieldsToValidate.push(
                        "university19",
                        "graduationYear19",
                        "graduationScore19",
                    );
                }
            } else if (["25/20"].includes(this.userId)) {
                fieldsToValidate = [
                    "bacSpecialization20",
                    "bacScore20",
                    "degreeType20",
                ];
                if (this.formData.degreeType20 === "إجازة") {
                    fieldsToValidate.push(
                        "university20",
                        "obtainedDegree20",
                        "graduationScore20",
                    );
                } else if (
                    this.formData.degreeType20 ===
                    "مؤهل تقني سامي في التصرف في الموارد البشرية"
                ) {
                    fieldsToValidate.push(
                        "university20",
                        "graduationYear20",
                        "graduationScore20",
                    );
                }
            } else if (["25/21"].includes(this.userId)) {
                fieldsToValidate = ["bacType21", "bacScore21", "degreeType21"];
                if (this.formData.degreeType21 === "إجازة") {
                    fieldsToValidate.push(
                        "university21",
                        "obtainedDegree21",
                        "graduationScore21",
                    );
                } else if (
                    this.formData.degreeType21 ===
                    "مؤهّل تقني سامٍ في الإلكترونيك والكهروتقنية والآلية"
                ) {
                    fieldsToValidate.push(
                        "university21",
                        "graduationYear21",
                        "graduationScore21",
                    );
                }
            } else if (["25/22"].includes(this.userId)) {
                fieldsToValidate = ["bacType22", "bacScore22", "degreeType22"];
                if (this.formData.degreeType22 === "إجازة") {
                    fieldsToValidate.push(
                        "university22",
                        "obtainedDegree22",
                        "graduationScore22",
                    );
                } else if (
                    this.formData.degreeType22 ===
                    "مؤهل تقني سامي في إدارة الأعمال: المحاسبة والمالية"
                ) {
                    fieldsToValidate.push(
                        "university22",
                        "graduationYear22",
                        "graduationScore22",
                    );
                }
            } else if (["25/23"].includes(this.userId)) {
                fieldsToValidate = [
                    "techCert23",
                    "trainingCenter23",
                    "graduationYear23",
                    "graduationScore23",
                ];
            } else if (["25/24"].includes(this.userId)) {
                fieldsToValidate = [
                    "studyLevel24",
                    "finalScore24",
                    "militaryCertOption24",
                ];
            } else if (["25/25", "25/26"].includes(this.userId)) {
                fieldsToValidate = [
                    "studyLevel25_26",
                    "finalScore25_26",
                    "militaryCertOption25_26",
                ];
            } else if (["25/27"].includes(this.userId)) {
                fieldsToValidate = [
                    "studyLevel25_27",
                    "finalScore25_27",
                    "professionalWarning25_27",
                ];
            } else if (["25/28"].includes(this.userId)) {
                fieldsToValidate = [
                    "studyLevel25_28",
                    "finalScore25_28",
                    "professionalWarning25_28",
                ];
            } else if (["25/29"].includes(this.userId)) {
                fieldsToValidate = [
                    "studyLevel25_29",
                    "finalScore25_29",
                    "professionalWarning25_29",
                ];
            } else if (
                ["25/30", "25/31", "25/32", "25/33"].includes(this.userId)
            ) {
                fieldsToValidate = ["finalScore25_30_33"];
            } else if (["25/34", "25/35"].includes(this.userId)) {
                fieldsToValidate = [
                    "finalScore25_34_35",
                    "drivingLicense25_34_35",
                ];
            }

            // validation للحقول المحددة
            fieldsToValidate.forEach((field) => this.validateField(field));

            return fieldsToValidate.every((field) => !this.errors[field]);
        },

        loadFromLocalStorage() {
            try {
                const savedData = localStorage.getItem("registrationFormData");
                if (savedData) {
                    const parsedData = JSON.parse(savedData);
                    // دمج البيانات المحفوظة مع البيانات الحالية
                    this.formData = { ...this.formData, ...parsedData };
                    console.log(
                        "تم تحميل البيانات من localStorage:",
                        this.formData,
                    );
                }

                const savedStep = localStorage.getItem("registrationFormStep");
                if (savedStep) {
                    this.step = parseInt(savedStep);
                }
            } catch (error) {
                console.error("خطأ في تحميل البيانات من localStorage:", error);
            }
        },

        saveToLocalStorage() {
            try {
                // حفظ البيانات
                localStorage.setItem(
                    "registrationFormData",
                    JSON.stringify(this.formData),
                );
                // حفظ الخطوة الحالية
                localStorage.setItem(
                    "registrationFormStep",
                    this.step.toString(),
                );
                // حفظ معرف المستخدم
                if (this.userId) {
                    localStorage.setItem("examId", this.userId);
                }

                console.log("تم حفظ البيانات في localStorage");
            } catch (error) {
                console.error("خطأ في حفظ البيانات في localStorage:", error);
            }
        },

        async nextStep() {
            // التحقق من صحة البيانات حسب الخطوة الحالية
            let isValid = false;

            if (this.step === 1) {
                isValid = this.validateStep1();
                if (!isValid) {
                    alert(
                        "يرجى تصحيح الأخطاء في المعلومات الشخصية قبل المتابعة",
                    );
                    return;
                }

                try {
                    const result = await ConcoursService.searchByNationalId(
                        this.formData.nationalId,
                    );
                    console.log("نتيجة البحث عن رقم بطاقة التعريف:", result);

                    if (result.data.found) {
                        alert(
                            "رقم بطاقة التعريف هذا مسجل مسبقاً. لا يمكنك التسجيل مرة أخرى.",
                        );
                        return;
                    }
                } catch (error) {
                    console.error("خطأ في الاتصال بالسيرفر:", error);
                    alert("تعذر الاتصال بالخادم. الرجاء المحاولة لاحقاً.");
                    return;
                }
            } else if (this.step === 2) {
                isValid = this.validateStep2();
                if (!isValid) {
                    alert(
                        "يرجى تصحيح الأخطاء في المعلومات الأكاديمية قبل المتابعة",
                    );
                    return;
                }
            }

            // إذا كنا في الخطوة الأخيرة، عملية التسجيل
            if (this.step === this.totalSteps) {
                this.submitForm();
            } else {
                // الانتقال للخطوة التالية
                this.step++;
                this.saveToLocalStorage();
            }
        },

        prevStep() {
            if (this.step > 1) {
                this.step--;
                this.saveToLocalStorage();
            }
        },

        submitForm() {
            this.isLoading = true;

            // محاكاة عملية الإرسال
            setTimeout(() => {
                try {
                    // حفظ البيانات النهائية
                    this.saveToLocalStorage();

                    // إضافة timestamp للتسجيل
                    const registrationData = {
                        ...this.formData,
                        userId: this.userId,
                        registrationDate: new Date().toISOString(),
                        completed: true,
                    };

                    localStorage.setItem(
                        "completedRegistration",
                        JSON.stringify(registrationData),
                    );

                    // alert("تم تسجيل البيانات بنجاح!");
                    // console.log("بيانات التسجيل المكتملة:", registrationData);

                    // التوجيه لصفحة المراجعة أو الرئيسية
                    this.$router.push("/review").catch((err) => {
                        console.error("Navigation failed:", err);
                    });
                } catch (error) {
                    console.error("خطأ في عملية التسجيل:", error);
                    alert(
                        "حدث خطأ أثناء حفظ البيانات. يرجى المحاولة مرة أخرى.",
                    );
                } finally {
                    this.isLoading = false;
                }
            }, 1500);
        },

        // وظيفة لحذف البيانات المحفوظة
        clearStoredData() {
            try {
                localStorage.removeItem("registrationFormData");
                localStorage.removeItem("registrationFormStep");

                localStorage.removeItem("completedRegistration");

                // إعادة تهيئة البيانات
                this.step = 1;
                this.userId = localStorage.getItem("examId") || null;

                // إعادة تعيين formData للقيم الافتراضية
                Object.keys(this.formData).forEach((key) => {
                    this.formData[key] = "";
                });

                // مسح الأخطاء
                Object.keys(this.errors).forEach((key) => {
                    this.errors[key] = "";
                });

                console.log("تم مسح جميع البيانات المحفوظة");
            } catch (error) {
                console.error("خطأ في مسح البيانات:", error);
            }
        },

        hasStoredData() {
            return localStorage.getItem("registrationFormData") !== null;
        },

        // وظيفة لاستعادة البيانات من نقطة معينة
        restoreFromCheckpoint() {
            if (this.hasStoredData()) {
                const shouldRestore = confirm(
                    " هل تريد استكمال التسجيل من حيث توقفت؟",
                );
                if (shouldRestore) {
                    this.loadFromLocalStorage();
                } else {
                    this.clearStoredData();
                }
            }
        },
    },
    created() {
        // تحميل معرف المستخدم
        this.userId = localStorage.getItem("examId") || this.userId;

        // إذا لم يكن هناك userId، حاول الحصول عليه من URL أو مصدر آخر
        if (!this.userId) {
            // يمكن الحصول على userId من route params أو query
            // this.userId = this.$route.params.examId || this.$route.query.examId;
            console.warn("معرف المستخدم غير متوفر");
        }

        console.log("معرف المستخدم المحمل:", this.userId);
    },

    mounted() {
        this.setDateLimits();
        this.restoreFromCheckpoint();
        // حفظ userId إذا كان متوفراً
        if (this.userId) {
            localStorage.setItem("examId", this.userId);
        }

        console.log("تم تحميل المكون بنجاح");
        console.log("الخطوة الحالية:", this.step);
        console.log("معرف المستخدم:", this.userId);
    },

    // تنظيف البيانات عند إزالة المكون
    beforeUnmount() {
        // حفظ البيانات الحالية قبل إغلاق المكون
        this.saveToLocalStorage();
    },
};
</script>

<style>
/* CSS كامل من الكود الأصلي، بدون تغيير أي حاجة */
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* Root Variables */
:root {
    --primary-dark: #001a33;
    --primary: #003366;
    --primary-light: #0055a5;
    --primary-lighter: #0066cc;
    --accent: #ffd700;
    --accent-dark: #ffb700;
    --success: #00c851;
    --danger: #ff4444;
    --warning: #ffbb33;
    --white: #ffffff;
    --light: #f8fafc;
    --dark: #1a202c;
    --shadow: rgba(0, 51, 102, 0.15);
    --shadow-dark: rgba(0, 26, 51, 0.25);
}

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: "Cairo", sans-serif;
}

.container {
    background: transparent !important;
    box-shadow: none !important;
    width: 100%;
    margin: 0 auto;
    padding: 20px 15px;
    display: flex;
    flex-direction: column;
    gap: 25px;
    background: transparent;
    box-shadow: none;
    box-sizing: border-box;
    min-height: 0;
    /* container يتوسع حسب المحتوى فقط */
}

/* Main Content */
.main-content {
    margin: -80px auto 0;
    position: relative;
    z-index: 5;
    max-width: 1300px;
}

/* Premium Notes Section */
.notes-section {
    background: linear-gradient(135deg, #fff8e1, #fffbf0, #fff8e1);
    border-radius: 35px;
    padding: 45px;
    border-right: 8px solid var(--accent);
    box-shadow:
        0 20px 50px rgba(255, 193, 7, 0.15),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    position: relative;
    overflow: hidden;
    margin-bottom: 40px;
}

.notes-title {
    font-size: 1.8rem;
    font-weight: 800;
    background: linear-gradient(135deg, var(--accent-dark), #b8860b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 35px;
    display: flex;
    align-items: center;
    gap: 15px;
}

.notes-list {
    list-style: none;
    padding: 0;
}

.notes-list li {
    background: var(--white);
    margin: 20px 0;
    padding: 25px;
    border-radius: 20px;
    box-shadow:
        0 8px 25px rgba(0, 0, 0, 0.08),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    border-right: 5px solid var(--accent);
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--dark);
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.notes-list li:hover {
    transform: translateX(-8px) translateY(-3px);
    box-shadow:
        0 15px 40px rgba(0, 0, 0, 0.12),
        0 0 0 1px rgba(255, 193, 7, 0.2);
}

/* Form Card */
.form-card {
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(25px);
    border-radius: 40px;
    padding: 60px;
    box-shadow:
        0 30px 80px rgba(0, 0, 0, 0.12),
        0 0 0 1px rgba(255, 255, 255, 0.5),
        inset 0 1px 0 rgba(255, 255, 255, 0.8);
    border: 1px solid rgba(0, 85, 165, 0.1);
    position: relative;
    overflow: hidden;
}

.form-card::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: linear-gradient(
        90deg,
        var(--accent),
        var(--primary-light),
        var(--accent)
    );
    border-radius: 40px 40px 0 0;
}

.form-header {
    text-align: center;
    margin-bottom: 40px;
    position: relative;
}

.form-header h3 {
    font-size: 2.5rem;
    font-weight: 800;
    background: linear-gradient(135deg, var(--primary), var(--primary-light));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
}

/* Premium Form Inputs */
.form-label {
    font-weight: 700;
    font-size: 1.1rem;
    color: var(--dark);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.form-label i {
    color: var(--primary-light);
    font-size: 1.2rem;
}

.form-control,
.premium-input {
    border: 2px solid rgba(0, 85, 165, 0.1);
    border-radius: 15px;
    padding: 15px 20px;
    font-size: 1.1rem;
    font-weight: 500;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(10px);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    width: 100%;
}

.form-control:focus,
.premium-input:focus {
    outline: none;
    border-color: var(--primary-light);
    box-shadow:
        0 0 0 4px rgba(0, 85, 165, 0.1),
        0 10px 30px rgba(0, 85, 165, 0.15);
    transform: translateY(-2px);
    background: var(--white);
}

.premium-input::placeholder {
    color: rgba(26, 32, 44, 0.6);
    font-style: italic;
}

.focused .form-label {
    color: var(--primary-light);
    transform: translateY(-2px);
}

.focused .form-label i {
    transform: scale(1.1);
}

/* Confirmation Checkbox */
.confirmation-check {
    background: linear-gradient(135deg, #f0f7ff, #e6f3ff);
    border-radius: 20px;
    padding: 25px;
    border-right: 5px solid var(--success);
    box-shadow: 0 10px 30px rgba(0, 200, 81, 0.1);
}

.confirmation-check .form-check-input {
    width: 20px;
    height: 20px;
    border: 2px solid var(--success);
    border-radius: 5px;
    margin-left: 10px;
}

.confirmation-check .form-check-input:checked {
    background-color: var(--success);
    border-color: var(--success);
}

.confirmation-check .form-check-label {
    font-weight: 600;
    font-size: 1.1rem;
    color: var(--dark);
    display: flex;
    align-items: center;
}

/* Action Buttons */
.form-actions {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    margin-top: 40px;
    flex-wrap: wrap;
}

.btn-cancel {
    background: linear-gradient(135deg, #6c757d, #5a6268);
    color: var(--white);
    border: none;
    padding: 18px 35px;
    border-radius: 50px;
    font-weight: 700;
    font-size: 1.2rem;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 10px 25px rgba(108, 117, 125, 0.3);
    position: relative;
    overflow: hidden;
}

.btn-cancel:hover {
    transform: translateY(-6px) scale(1.05);
    box-shadow: 0 20px 40px rgba(108, 117, 125, 0.4);
    color: var(--white);
}

/* Loading animation */
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, var(--primary), var(--primary-light));
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
    transition: opacity 0.5s ease;
}

.loader {
    width: 80px;
    height: 80px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid var(--accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* Premium animations */
.fade-in {
    animation: premiumFadeIn 1.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-in {
    animation: premiumSlideIn 1s cubic-bezier(0.4, 0, 0.2, 1);
}

.scale-in {
    animation: premiumScaleIn 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes premiumFadeIn {
    from {
        opacity: 0;
        transform: translateY(40px) scale(0.95);
    }

    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@keyframes premiumSlideIn {
    from {
        opacity: 0;
        transform: translateX(60px) rotateY(10deg);
    }

    to {
        opacity: 1;
        transform: translateX(0) rotateY(0deg);
    }
}

@keyframes premiumScaleIn {
    from {
        opacity: 0;
        transform: scale(0.8) rotateZ(-5deg);
    }

    to {
        opacity: 1;
        transform: scale(1) rotateZ(0deg);
    }
}

/* Scroll-triggered animations */
.reveal {
    opacity: 0;
    transform: translateY(50px);
    transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

.reveal.active {
    opacity: 1;
    transform: translateY(0);
}

/* Ripple effect */
@keyframes ripple {
    to {
        transform: scale(4);
        opacity: 0;
    }
}

/* Responsive Design */

.mb-3 {
    margin-bottom: 1rem;
}

.mb-4 {
    margin-bottom: 1.5rem;
}

.mt-3 {
    margin-top: 1rem;
}

.text-danger {
    color: var(--danger);
    font-size: 0.9rem;
    margin-top: 5px;
}

@media (max-width: 768px) {
    .main-title {
        font-size: 2.8rem;
    }

    .form-card {
        padding: 35px 25px;
        margin: -60px 15px 0;
        border-radius: 25px;
    }

    .notes-section {
        padding: 30px 20px;
        margin: 20px 15px 40px;
    }

    .form-header h3 {
        font-size: 2rem;
        flex-direction: column;
        gap: 10px;
    }

    .form-actions {
        flex-direction: column;
    }

    .form-actions .btn {
        width: 100%;
        justify-content: center;
    }

    .premium-input {
        font-size: 1rem;
        padding: 12px 15px;
    }

    .form-label {
        font-size: 1rem;
    }

    .col-md-6 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}

@media (max-width: 576px) {
    .form-card {
        padding: 25px 15px;
    }

    .main-title {
        font-size: 2.2rem;
    }
}

/* Enhanced Select Styling */
select.premium-input,
select.form-control {
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%230055a5' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6,9 12,15 18,9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: left 15px center;
    background-size: 20px;
    padding-left: 45px;
}

/* Textarea specific styling */
textarea.premium-input,
textarea.form-control {
    resize: vertical;
    min-height: 120px;
    font-family: inherit;
}

textarea.premium-input:focus,
textarea.form-control:focus {
    min-height: 150px;
}

/* Enhanced validation styling */
.premium-input:invalid,
.form-control:invalid {
    border-color: var(--danger);
}

.premium-input:valid,
.form-control:valid {
    border-color: var(--success);
}

/* Focus states for better accessibility */
.premium-input:focus,
.form-control:focus,
.btn:focus,
.form-check-input:focus {
    outline: 2px solid var(--primary-light);
    outline-offset: 2px;
}

.loading-screen {
    position: fixed;
    inset: 0;
    background: linear-gradient(135deg, var(--primary), var(--primary-light));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: white;
    z-index: 9999;
}

.spinner {
    width: 50px;
    height: 50px;
    border: 4px solid rgba(255, 255, 255, 0.3);
    border-top: 4px solid var(--accent);
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 20px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.st1 {
    border: 2px solid #afc7ea;
    border-radius: 8px;
    padding: 10px;
    background-color: #e7f1ff;
    margin-bottom: 20px;
    box-shadow: 0 4px 6px rgba(13, 110, 253, 0.1);
}

form,
.row {
    direction: rtl;
    /* الكتابة من اليمين لليسار */
    color: #333;
}

/* العناوين */
h2 {
    font-size: 1.8rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
    color: #0d6efd;
    /* أزرق Bootstrap الأساسي */
}

/* الحقول */
.form-control {
    border-radius: 8px;
    border: 1px solid #ccc;
    padding: 10px 12px;
    transition: all 0.3s ease;
}

.form-control:focus {
    border-color: #0d6efd;
    box-shadow: 0 0 5px rgba(13, 110, 253, 0.5);
    outline: none;
}

/* التسميات */
.form-label {
    font-weight: 600;
    margin-bottom: 5px;
}

/* رسائل الخطأ */
.text-danger {
    font-size: 0.85rem;
    margin-top: 3px;
    display: block;
}

/* الأعمدة */
.col-md-6 {
    padding-left: 10px;
    padding-right: 10px;
}

/* الحاوية للأزرار */
.mt-4 {
    display: flex;
    gap: 20px;
    /* مسافة بين الزرين */
}

/* زر التالي على اليسار ويشغل نصف الحاوية */
button.btn-primary {
    flex: 1;
    /* يشغل كل المساحة المتاحة في جانبه */
    background-color: #0055a5;
    border: none;
    color: #fff;
    font-weight: bold;
    border-radius: 8px;
    padding: 10px 20px;
    transition: all 0.3s ease;
    margin-bottom: 20px;
}

button.btn-primary:hover {
    background-color: #7da0d3;
}

/* زر رجوع للرئيسية على اليمين ويشغل نصف الحاوية */
button.btn-secondary {
    flex: 1;
    /* يشغل كل المساحة المتاحة في جانبه */
    background-color: #969ea6;
    border: none;
    color: #fff;
    font-weight: bold;
    border-radius: 8px;
    padding: 10px 20px;
    transition: all 0.3s ease;
    margin-bottom: 20px;
}

button.btn-secondary:hover {
    background-color: #5c636a;
}

/* المسافات */
.mt-4 {
    margin-top: 1.5rem;
}

.mb-3 {
    margin-bottom: 1rem;
}

/* Responsive */
@media (max-width: 768px) {
    .col-md-6 {
        width: 100%;
        padding: 0;
        margin-bottom: 1rem;
    }
}

/* Footer */
.footer {
    margin-top: 100px;
    background: linear-gradient(
        135deg,
        var(--primary-dark),
        var(--primary),
        var(--primary-light)
    );
    color: var(--white);
    padding: 60px 0;
    text-align: center;
    box-shadow:
        0 -20px 50px rgba(0, 51, 102, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
}

.footer::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(
        90deg,
        var(--accent),
        var(--white),
        var(--accent)
    );
}

.footer-text {
    font-size: 1.3rem;
    font-weight: 600;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 2;
}
</style>
